export const customBlocks = {
  desktop: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mx-auto u-center w-full max-w-[1100px]',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    VitrinProject: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'vitrin',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    OyunlarMasthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarMasthead',
            className: 'mx-auto u-center w-full max-w-[1100px]',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    OyunlarInpage1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage1',
            className: 'mx-auto max-w-[1100px]',
          },
        },
      ],
    },
    OyunlarInpage4: {
      showAt: [(index) => index >= 5 && index % 10 === 5, (index) => index >= 9 && index % 10 === 2],
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage2',
          },
          showAt: (index) => index >= 5 && index % 10 === 5,
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage3',
          },
          showAt: (index) => index >= 9 && index % 10 === 2,
        },
      ],
    },
    oyunlarSkyscrapperLeft: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarSkyscrapperLeft',
          },
        },
      ],
    },
    oyunlarSkyscrapperRight: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarSkyscrapperRight',
          },
        },
      ],
    },
    OyunlarFooter: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarFooter',
            className: 'mx-auto u-center w-full max-w-[1100px]',
          },
        },
      ],
    },
    Redirect: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'redirect',
            lazy: false,
            className: 'mx-auto u-center',
          },
        },
      ],
    },
  },
  mobile: {
    masthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'masthead',
            className: 'mx-auto u-center w-full max-w-[1100px]',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    InstagramMasthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'InstagramMasthead',
            lazy: false,
          },
        },
      ],
    },
    bodyBottom: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'interstitial',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    VitrinProject: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'vitrin',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
      ],
    },
    OyunlarMasthead: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarMasthead',
            className: 'mx-auto',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'datacollect',
            style: 'width: 1px; height: 1px',
            lazy: false,
          },
        },
        {
          componentInfo: {
            type: 'FooterAd',
          },
        },
      ],
    },
    OyunlarInpageMobile1: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage1',
            className: 'mx-auto',
          },
        },
      ],
    },
    OyunlarInpageMobile2: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage2',
            className: 'mx-auto',
          },
        },
      ],
    },
    OyunlarInpageMobile3: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'oyunlarInpage3',
            className: 'mx-auto mt-9',
          },
        },
      ],
    },
    Redirect: {
      ads: [
        {
          componentInfo: {
            type: 'GPT',
            'unit-name': 'redirect',
            lazy: false,
            className: 'mx-auto u-center',
          },
        },
      ],
    },
  },
};
